import c0 from './address_geocode_prefill_controller';
import c1 from './ama_publish_controller';
import c2 from './amount_toggle_controller';
import c3 from './auto_save_controller';
import c4 from './autolink_controller';
import c5 from './beacon_link_controller';
import c6 from './bridge/beacon_link_controller';
import c7 from './bridge/intercom_controller';
import c8 from './bridge/menu_controller';
import c9 from './bridge/navigation_controller';
import c10 from './character_count_controller';
import c11 from './click_tracker_controller';
import c12 from './confirm_submit_controller';
import c13 from './confirmation_controller';
import c14 from './copy_to_clipboard_controller';
import c15 from './custom_domain_validation_controller';
import c16 from './elapsed_controller';
import c17 from './email_validation_controller';
import c18 from './expandable_content_controller';
import c19 from './extra_support_controller';
import c20 from './feed_item_switcher_controller';
import c21 from './form_controller';
import c22 from './highcharts_controller';
import c23 from './image_preview_controller';
import c24 from './inline_edit_controller';
import c25 from './live_activity_feed_controller';
import c26 from './live_console_controller';
import c27 from './live_poll_dashboard_controller';
import c28 from './live_poll_options_controller';
import c29 from './local_time_controller';
import c30 from './login_code_controller';
import c31 from './login_controller';
import c32 from './new_tab_link_controller';
import c33 from './notification_preferences_controller';
import c34 from './password_validator_controller';
import c35 from './plan_toggle_controller';
import c36 from './plan_unwrap_controller';
import c37 from './play_controls_controller';
import c38 from './playlist_sort_confirm_controller';
import c39 from './post_episode_picker_controller';
import c40 from './preview_controller';
import c41 from './preview_target_controller';
import c42 from './promotion_order_controller';
import c43 from './range_selector_controller';
import c44 from './search_filter_controller';
import c45 from './search_toggle_controller';
import c46 from './settings_search_controller';
import c47 from './share_link_controller';
import c48 from './sortable_list_controller';
import c49 from './status_page_controller';
import c50 from './stripe_confirm_controller';
import c51 from './stripe_payment_controller';
import c52 from './switch_subdomain_controller';
import c53 from './tiptap_controller';
import c54 from './tom_select_controller';
import c55 from './trix_default_message_controller';
import c56 from './trix_no_attachments_controller';
import c57 from './trix_restricted_toolbar_controller';
import c58 from './trix_upload_controller';
import c59 from './typed_confirmation_controller';
import c60 from './visibility_toggle_controller';
import c61 from './welcome_message_controller';
export const definitions = [
	{identifier: 'address-geocode-prefill', controllerConstructor: c0},
	{identifier: 'ama-publish', controllerConstructor: c1},
	{identifier: 'amount-toggle', controllerConstructor: c2},
	{identifier: 'auto-save', controllerConstructor: c3},
	{identifier: 'autolink', controllerConstructor: c4},
	{identifier: 'beacon-link', controllerConstructor: c5},
	{identifier: 'bridge--beacon-link', controllerConstructor: c6},
	{identifier: 'bridge--intercom', controllerConstructor: c7},
	{identifier: 'bridge--menu', controllerConstructor: c8},
	{identifier: 'bridge--navigation', controllerConstructor: c9},
	{identifier: 'character-count', controllerConstructor: c10},
	{identifier: 'click-tracker', controllerConstructor: c11},
	{identifier: 'confirm-submit', controllerConstructor: c12},
	{identifier: 'confirmation', controllerConstructor: c13},
	{identifier: 'copy-to-clipboard', controllerConstructor: c14},
	{identifier: 'custom-domain-validation', controllerConstructor: c15},
	{identifier: 'elapsed', controllerConstructor: c16},
	{identifier: 'email-validation', controllerConstructor: c17},
	{identifier: 'expandable-content', controllerConstructor: c18},
	{identifier: 'extra-support', controllerConstructor: c19},
	{identifier: 'feed-item-switcher', controllerConstructor: c20},
	{identifier: 'form', controllerConstructor: c21},
	{identifier: 'highcharts', controllerConstructor: c22},
	{identifier: 'image-preview', controllerConstructor: c23},
	{identifier: 'inline-edit', controllerConstructor: c24},
	{identifier: 'live-activity-feed', controllerConstructor: c25},
	{identifier: 'live-console', controllerConstructor: c26},
	{identifier: 'live-poll-dashboard', controllerConstructor: c27},
	{identifier: 'live-poll-options', controllerConstructor: c28},
	{identifier: 'local-time', controllerConstructor: c29},
	{identifier: 'login-code', controllerConstructor: c30},
	{identifier: 'login', controllerConstructor: c31},
	{identifier: 'new-tab-link', controllerConstructor: c32},
	{identifier: 'notification-preferences', controllerConstructor: c33},
	{identifier: 'password-validator', controllerConstructor: c34},
	{identifier: 'plan-toggle', controllerConstructor: c35},
	{identifier: 'plan-unwrap', controllerConstructor: c36},
	{identifier: 'play-controls', controllerConstructor: c37},
	{identifier: 'playlist-sort-confirm', controllerConstructor: c38},
	{identifier: 'post-episode-picker', controllerConstructor: c39},
	{identifier: 'preview', controllerConstructor: c40},
	{identifier: 'preview-target', controllerConstructor: c41},
	{identifier: 'promotion-order', controllerConstructor: c42},
	{identifier: 'range-selector', controllerConstructor: c43},
	{identifier: 'search-filter', controllerConstructor: c44},
	{identifier: 'search-toggle', controllerConstructor: c45},
	{identifier: 'settings-search', controllerConstructor: c46},
	{identifier: 'share-link', controllerConstructor: c47},
	{identifier: 'sortable-list', controllerConstructor: c48},
	{identifier: 'status-page', controllerConstructor: c49},
	{identifier: 'stripe-confirm', controllerConstructor: c50},
	{identifier: 'stripe-payment', controllerConstructor: c51},
	{identifier: 'switch-subdomain', controllerConstructor: c52},
	{identifier: 'tiptap', controllerConstructor: c53},
	{identifier: 'tom-select', controllerConstructor: c54},
	{identifier: 'trix-default-message', controllerConstructor: c55},
	{identifier: 'trix-no-attachments', controllerConstructor: c56},
	{identifier: 'trix-restricted-toolbar', controllerConstructor: c57},
	{identifier: 'trix-upload', controllerConstructor: c58},
	{identifier: 'typed-confirmation', controllerConstructor: c59},
	{identifier: 'visibility-toggle', controllerConstructor: c60},
	{identifier: 'welcome-message', controllerConstructor: c61},
];
